import type { API } from 'chessboard/api/config/types';
import type { Game } from 'chessboard/model/game/types';
import { getExtendedNode } from 'chessboard/model/game/get-extended-node';

/**
 * Create the getLine method.
 */
export function createGetLine(context: API.Context) {
  function getLine(id: 0): Game.Line;

  function getLine(id: number): Game.Line | undefined;

  /**
   * Get a line.
   */
  function getLine(id: number): Game.Line | undefined {
    const { game } = context;

    const startingMoveNumber = game.startingMoveNumber();
    const line: Game.Line = context.api.getRawLines()[id];

    if (!line) {
      if (id === 0) {
        throw new Error('Expected a main line');
      }

      return undefined;
    }

    line.forEach((gameMove: Game.Move.Node, ndx) => {
      const extendedNode = <Game.Move.Node>getExtendedNode({ move: gameMove, startingMoveNumber });

      line[ndx] = extendedNode;
    });

    return line;
  }

  return getLine;
}
